import React, { useEffect, useRef, useState } from "react";
import LiveInformations from "./LiveInformations";
import { ReactComponent as ArrowIcon } from "../../img/icons/arrowdown.svg";
import VideoPlayer from "../VideoPlayer";
import styled, { useTheme } from "styled-components";
import "./slider.scss";
import { BrowserView } from "react-device-detect";
import axios from "axios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { ENV_CONFIG } from "../../config/environment-unified";
import useTranslation from "../../hooks/useTranslation";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Hls from "hls.js";

// Component pour afficher le message "Aucun stream en direct"
const NoStreamsMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  background: ${({ theme }) => theme.color.secondaryBg};
  border-radius: 12px;
  margin: 20px 0;
  padding: 40px;
  text-align: center;
  color: ${({ theme }) => theme.color.primaryText};
  
  h3 {
    font-size: 24px;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.color.primaryText};
  }
  
  p {
    font-size: 16px;
    margin-bottom: 8px;
    opacity: 0.8;
  }
  
  .icon {
    font-size: 48px;
    margin-bottom: 20px;
    opacity: 0.6;
  }
  
  @media only screen and (max-width: 768px) {
    height: 300px;
    padding: 20px;
    
    h3 {
      font-size: 20px;
    }
    
    p {
      font-size: 14px;
    }
    
    .icon {
      font-size: 36px;
    }
  }
`;

const Stream = styled.div`
  max-width: 100%;
  /* width: 300px; */
  display: flex;
  /* justify-content:; */
  align-items: center;
  margin-bottom: 70px;
  padding: 0 5vw;
  display: ${({ loading }) => (loading === 1 ? "none" : "flex")};
  @media only screen and (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 0;
  }
`;
const Informations = styled.div`
  z-index: 6;
  @media only screen and (max-width: 992px) {
    order: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
`;
const NavigationButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 9.64px;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 41.36px;
    height: 41.36px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.color.secondaryBg};
    cursor: pointer;
    transition: transform 200ms;
    img {
      path {
        fill: ${({ theme }) => theme.color.primaryText};
      }
    }
    :hover {
      transition: transform 200ms;
      transform: scale(1.07);
    }
    :nth-child(1) {
      svg {
        transform: rotate(90deg);
      }
    }
    :nth-child(2) {
      svg {
        transform: rotate(-90deg);
      }
    }
    @media only screen and (max-width: 522px) {
      flex-direction: column;
      :nth-child(1) {
        svg {
          transform: rotate(360deg);
        }
      }
      :nth-child(2) {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  @media only screen and (max-width: 992px) {
    margin-bottom: 20px;
  }
`;

const SkeletonStyle = styled.div`
  align-items: center;
  flex-direction: row !important;
  span {
    display: inline-block;
  }
  &,
  div {
    display: flex;
    flex-direction: column;
  }
  .left {
    width: 40%;
    > div:nth-child(1) {
      flex-direction: row;
      align-items: center;
      > span {
        margin-right: 10px;
      }
    }
    > div:nth-child(2) {
      > div {
        margin-top: 15px;
        margin-bottom: 10px;
        flex-direction: row;

        > span:not(:last-child) {
          margin-right: 5px;
        }
      }
    }
  }
  .right {
    flex: 1;
    position: relative;
    height: 20vw;
    display: flex;
    align-items: center;
    > div {
      position: absolute;
      inset: 0;
      > span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        :nth-child(1) {
          z-index: 3;
          left: 0px;
          span {
            width: 30vw;
            height: 20vw;
          }
        }
        :nth-child(2) {
          z-index: 2;
          left: 20%;
          span {
            width: 25vw;
            height: 17vw;
          }
        }
        :nth-child(3) {
          z-index: 1;
          left: 40%;
          span {
            width: 20vw;
            height: 14vw;
          }
        }
      }
    }
  }
`;
const SliderSkeleton = (props) => {
  const theme = useTheme();
  return (
    <SkeletonTheme color={theme.color.secondaryBg} highlightColor={theme.color.background}>
      <SkeletonStyle>
        <div className="left">
          <div>
            <Skeleton circle={true} width={70} height={70} />
            <div>
              <Skeleton width={150} />
              <Skeleton width={150} />
            </div>
          </div>
          <div>
            <div>
              <Skeleton width={60} />
              <Skeleton width={60} />
              <Skeleton width={60} />
            </div>
            <Skeleton width={150} />
            <Skeleton width={200} />
            <Skeleton width={130} />
          </div>
        </div>
        <div className="right">
          <div>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </div>
        </div>
      </SkeletonStyle>
    </SkeletonTheme>
  );
};

export default function LiveSlider(props) {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0); // Commencer à 0
  const [loading, setLoading] = useState(1); // Commencer avec loading
  const [livesData, setlivesData] = useState([]);
  const history = useHistory();
  const isLoggedIn = useSelector((s) => s.user?.isLoggedIn);
  const MAX_SLIDES = 6;
  const slides = (Array.isArray(livesData) ? livesData : []).slice(0, MAX_SLIDES);
  // If true, load/play muted previews for non-active tiles too.
  // Note: this increases bandwidth/CPU (up to 6 HLS players).
  const PRELOAD_ALL_STREAMS = true;

  const StreamPreview = ({ src, poster, active }) => {
    const videoRef = useRef(null);

    useEffect(() => {
      const video = videoRef.current;
      if (!video || !src) return;

      let hls;
      try {
        // Always muted for previews to satisfy autoplay policies
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
      } catch (_) { }

      const nativeHlsSupport = (() => {
        try {
          return (
            video.canPlayType?.("application/vnd.apple.mpegurl") ||
            video.canPlayType?.("application/x-mpegURL") ||
            ""
          );
        } catch (_) {
          return "";
        }
      })();

      const isProbablyIOS = (() => {
        try {
          const ua = navigator?.userAgent || "";
          const iOSUA = /iP(hone|od|ad)/i.test(ua);
          const iPadOS = navigator?.platform === "MacIntel" && (navigator?.maxTouchPoints || 0) > 1;
          return iOSUA || iPadOS;
        } catch (_) {
          return false;
        }
      })();

      const isProbablySafari = (() => {
        try {
          const ua = navigator?.userAgent || "";
          return /Safari/i.test(ua) && !/Chrome|CriOS|Chromium|Android/i.test(ua);
        } catch (_) {
          return false;
        }
      })();

      const isHls =
        typeof src === "string" &&
        (src.endsWith(".m3u8") || src.includes("hls") || src.includes("playback"));

      const preferNativeHls = !!nativeHlsSupport && (isProbablyIOS || isProbablySafari);

      if (isHls && preferNativeHls) {
        // Prefer native HLS on Safari/iOS for reliability.
        try {
          video.src = src;
          video.load();
          video.play().catch(() => { });
        } catch (_) { }
      } else if (isHls && Hls.isSupported()) {
        hls = new Hls({
          debug: false,
          enableWorker: true,
          lowLatencyMode: true,
          backBufferLength: 30,
          maxBufferLength: 10,
          maxMaxBufferLength: 20,
        });
        hls.loadSource(src);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          // Try autoplay silently
          video.play().catch(() => { });
        });
      } else {
        // Native HLS (Safari) or non-HLS sources
        try {
          video.src = src;
          video.load();
          video.play().catch(() => { });
        } catch (_) { }
      }

      return () => {
        try {
          if (hls) hls.destroy();
        } catch (_) { }
        try {
          // Stop network + decoding
          if (video) {
            video.pause();
            video.removeAttribute("src");
            video.load();
          }
        } catch (_) { }
      };
    }, [src]);

    return (
      <div style={{ width: "100%", height: "100%", position: "relative" }}>
        <video
          ref={videoRef}
          muted
          playsInline
          autoPlay
          preload="auto"
          poster={poster || undefined}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            filter: active ? "none" : "saturate(0.95) brightness(0.95)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 12,
            left: 12,
            background: "#ee4c50",
            color: "white",
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: "0.12em",
            padding: "4px 8px",
            borderRadius: 4,
            textTransform: "uppercase",
            userSelect: "none",
            pointerEvents: "none",
          }}
        >
          LIVE
        </div>
      </div>
    );
  };

  useEffect(() => {
    const fetchLiveStreams = async () => {
      try {
        // console.log("🎥 Tentative de récupération des lives depuis l'API...");
        const response = await axios.get(`${ENV_CONFIG.STREAMS_ENDPOINT}?recommended=`);

        // console.log("📡 Réponse API reçue:", response.data);
        // console.log("📡 Type de response.data:", typeof response.data);
        // console.log("📡 Est-ce un tableau?", Array.isArray(response.data));

        // Vérifier si response.data est un tableau
        let liveStreams = [];
        if (response.data && Array.isArray(response.data)) {
          liveStreams = response.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          // Si la réponse est dans un objet { data: [...] }
          liveStreams = response.data.data;
        } else if (response.data && response.data.lives && Array.isArray(response.data.lives)) {
          // Si la réponse est dans un objet { lives: [...] }
          liveStreams = response.data.lives;
        }

        if (liveStreams.length > 0) {
          console.log("🔍 Raw API response:", liveStreams);
          const transformedLives = liveStreams.map((live, index) => {
            console.log(`🔄 Transforming stream ${index}:`, {
              tags: live.tags,
              tagsType: typeof live.tags,
              game: live.stream_games || live.game,
              username: live.username
            });

            return {
              // Keep thumbnail null if missing so the UI shows the custom fallback card
              // (instead of rendering a placeholder image URL).
              thumbnail: live.thumbnailGif || live.thumbnail || null,
              src: live.playbackLink, // <-- utilise playbackLink fourni par l'API backend
              game: live.stream_games?.name || live.game?.name || live.game || "Gaming",
              username: live.username || "Streamer",
              avatar: live.avatar || "https://via.placeholder.com/70x70/2a2a2a/ffffff?text=?",
              title: live.title || "Live Stream",
              tags: (() => {
                try {
                  if (Array.isArray(live.tags)) return live.tags;
                  if (typeof live.tags === 'string') return [live.tags];
                  if (live.tags && typeof live.tags === 'object') return Object.values(live.tags);
                  return ["Live", "Gaming"];
                } catch (e) {
                  console.error('❌ Error processing tags:', e);
                  return ["Live", "Gaming"];
                }
              })(),
              about: live.about || "Live streaming content",
              isLive: true,
              channelArn: live.channelArn, // Pour le debug
              viewerCount: live.viewerCount || 0,
              stream_games: live.stream_games, // Pass through for debugging
              currentEventId: live.currentEventId || null,
              watchTarget: live.username ? `/stream/${live.username}` : null,
            };
          });
          console.log("✅ Streams trouvés:", transformedLives.length);

          // Optional: fetch linked event details for streams that are attached to an event
          const eventIds = Array.from(
            new Set(
              transformedLives
                .filter(l => l.currentEventId)
                .map(l => l.currentEventId)
            )
          );

          if (eventIds.length === 0) {
            setlivesData(transformedLives);
          } else {
            try {
              const eventRequests = eventIds.map(id =>
                axios
                  .get(`${ENV_CONFIG.EVENTS_ENDPOINT}/events/by-id/${id}`, { withCredentials: true })
                  .then(res => ({ id, event: res.data.event }))
                  .catch(err => {
                    console.error("❌ Error fetching event for live stream:", id, err);
                    return { id, event: null };
                  })
              );

              const eventsResults = await Promise.all(eventRequests);
              const eventMap = {};
              eventsResults.forEach(({ id, event }) => {
                if (event) {
                  eventMap[id] = event;
                }
              });

              const enrichedLives = transformedLives.map(live => {
                const event = live.currentEventId ? eventMap[live.currentEventId] : null;
                if (!event) return live;

                const eventCategorySlug = event.category?.slug || null;
                const eventCategoryName = String(event.category?.name || "").trim().toLowerCase();
                const isTournamentEvent =
                  eventCategorySlug === "tournament" ||
                  eventCategoryName === "tournament" ||
                  eventCategoryName === "tournoi";

                const watchTarget = live.username
                  ? isTournamentEvent
                    ? `/events/${event.slug}/watch?pov=${encodeURIComponent(live.username)}`
                    : `/stream/${live.username}`
                  : isTournamentEvent
                    ? `/events/${event.slug}/watch`
                    : null;

                return {
                  ...live,
                  linkedEvent: {
                    id: event.id,
                    slug: event.slug,
                    name: event.name,
                    category: event.category?.name,
                    categorySlug: eventCategorySlug,
                    ticketPrice: event.ticketPrice
                  },
                  watchTarget,
                };
              });

              setlivesData(enrichedLives);
            } catch (e) {
              console.error("❌ Error enriching lives with events:", e);
              setlivesData(transformedLives);
            }
          }
        } else {
          console.log("ℹ️ Aucun stream en direct trouvé");
          setlivesData([]); // Pas de fallback - tableau vide
        }
      } catch (error) {
        console.error("❌ Erreur lors de la récupération des lives:", error);
        console.log("ℹ️ Pas de fallback - affichage du message d'erreur");
        setlivesData([]); // Pas de fallback - tableau vide
      } finally {
        setLoading(0);
      }
    };

    fetchLiveStreams();
  }, []);

  // This slider layout is driven by 6 radio buttons + CSS rules.
  // If index goes beyond 0..5, no radio is checked and all slides overlap (only one appears).
  useEffect(() => {
    const len = slides.length;
    if (len > 0 && index >= len) setIndex(0);
  }, [slides.length]); // eslint-disable-line react-hooks/exhaustive-deps

  async function handleSlideClick(i, live) {
    // If the clicked slide is the active one (video), navigate to the appropriate watch page
    if (i === index && live) {
      const target = live?.watchTarget || (live?.username ? `/stream/${live.username}` : null);

      if (!target) return;

      // Guests: open auth modal first, then redirect back after login.
      if (!isLoggedIn) {
        try {
          localStorage.setItem("postLoginRedirect", target);
        } catch (_) { }
        history.push("/?noAuth");
        return;
      }

      history.push(target);
      return;
    }
    // Otherwise, just move the selection in the slider
    setIndex(i);
  }

  function move(i) {
    const dataLength = slides.length;
    if (dataLength <= 1) {
      return;
    }
    if (i === 1) {
      if (index === 0) {
        setIndex(dataLength - 1);
        return;
      }
      setIndex(index - 1);
    } else {
      if (index === dataLength - 1) {
        setIndex(0);
        return;
      }
      setIndex(index + 1);
    }
  }

  // Debug logging
  // console.log('🎯 LiveSlider render - livesData:', livesData, 'Type:', typeof livesData, 'IsArray:', Array.isArray(livesData));

  // Si pas de streams et pas en chargement, afficher le message
  if (loading === 0 && slides.length === 0) {
    return (
      <NoStreamsMessage>
        <div className="icon">📺</div>
        <h3>{t('carousel.aucun_stream_en')}</h3>
        <p>{t('carousel.il_ny_a')}</p>
        <p>{t('carousel.revenez_plus_tard')}</p>
      </NoStreamsMessage>
    );
  }

  return (
    <>
      {loading === 1 && <SliderSkeleton />}
      <Stream loading={loading}>
        <Informations>
          <LiveInformations
            live={slides[index]}
            index={index}
            setIndex={(e) => {
              setIndex(e);
            }}
            lives={slides}
          ></LiveInformations>
          <BrowserView>
            <NavigationButtons>
              <div
                onClick={() => {
                  move(-1);
                }}
              >
                <ArrowIcon />
              </div>
              <div
                onClick={() => {
                  move(1);
                }}
              >
                <ArrowIcon />
              </div>
            </NavigationButtons>
          </BrowserView>
        </Informations>
        <SliderContainer>
          <div id="slider">
            <input type="radio" name="slider" id="s1" checked={index === 0} onChange={() => setIndex(0)} />
            <input type="radio" name="slider" id="s2" checked={index === 1} onChange={() => setIndex(1)} />
            <input type="radio" name="slider" id="s3" checked={index === 2} onChange={() => setIndex(2)} />
            <input type="radio" name="slider" id="s4" checked={index === 3} onChange={() => setIndex(3)} />
            <input type="radio" name="slider" id="s5" checked={index === 4} onChange={() => setIndex(4)} />
            <input type="radio" name="slider" id="s6" checked={index === 5} onChange={() => setIndex(5)} />
            {slides.map(function (live, i) {
              // console.log(`🎬 Rendu stream ${i}:`, {
              //   username: live.username,
              //   game: live.stream_games || live.game,
              //   src: live.src,
              //   hasValidSrc: !!live.src
              // });
              return (
                <div
                  key={i}
                  onClick={(e) => {
                    // Allow interacting with controls (volume slider, buttons) without triggering selection/navigation.
                    try {
                      if (e?.defaultPrevented) return;
                      const isControl =
                        e?.target?.closest?.(
                          "#control-bar, button, input, .e-range, .vjs-control-bar, .vjs-menu, .vjs-slider, .vjs-button"
                        );
                      if (isControl) return;
                    } catch (_) { }
                    handleSlideClick(i, live);
                  }}
                  id={"slider" + (i + 1)}
                >
                  {index !== i ? (
                    PRELOAD_ALL_STREAMS && live?.src ? (
                      <StreamPreview
                        src={live.src}
                        poster={live.thumbnail || live.avatar || undefined}
                        active={false}
                      />
                    ) : live && live.thumbnail ? (
                      <img src={live.thumbnail} alt={`${live.username} - ${live.game}`} />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          background:
                            "radial-gradient(120% 120% at 20% 0%, rgba(255,255,255,0.08) 0%, rgba(0,0,0,0.35) 45%, rgba(0,0,0,0.7) 100%), #111827",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "rgba(255,255,255,0.92)",
                          flexDirection: "column",
                          gap: "10px",
                          position: "relative",
                        }}
                      >
                        {live?.avatar ? (
                          <img
                            src={live.avatar}
                            alt={live.username || "Streamer avatar"}
                            style={{
                              width: "56px",
                              height: "56px",
                              borderRadius: "14px",
                              objectFit: "cover",
                              border: "1px solid rgba(255,255,255,0.22)",
                              boxShadow: "0 10px 26px rgba(0,0,0,0.45)",
                            }}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.style.display = "none";
                            }}
                          />
                        ) : (
                          <div style={{ fontSize: "22px" }}>LIVE</div>
                        )}

                        <div style={{ fontSize: "12px", fontWeight: 700, opacity: 0.95 }}>
                          {live?.username || "Live stream"}
                        </div>
                        <div style={{ fontSize: "11px", opacity: 0.72 }}>
                          {live?.linkedEvent?.category || live?.game || "Gaming"}
                        </div>
                      </div>
                    )
                  ) : (
                    <VideoPlayer
                      type="hls"
                      id={"player" + i}
                      src={live.src} // <-- c'est maintenant l'URL IVS depuis la DB
                      isLive={true}
                      isMute={true}
                      autoPlay={true}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </SliderContainer>
      </Stream>
    </>
  );
}
const SliderContainer = styled.div`
  /* background: black; */
  height: 40vw;
  min-height:400px;
  max-height:400px;

  align-items: center;
  justify-content: center;
  display: flex;
  margin-left: 5vw;
  @media only screen and (max-width: 992px) {
    height: 39vw;
    width: 52vw;
    margin-left: 0vw;
  }
  @media only screen and (max-width: 700px) {
    height: 40vw;
    width: 50vw;
    margin-left: 0vw;
  }
  @media only screen and (max-width: 522px) {
    margin-left: 0px;

    margin-top: 70px;
    height: 250px;
    width: 90vw;
    min-width: 50vw;
    min-height:200px;
  max-height:250px;


  }
  #slider {
    height: 80%;
    width: 40vw;
    max-width: 550px;
    min-width: 400px;

    min-height: 158px;
    @media only screen and (max-width: 1400px) {
      width: 30vw;
      height: 20vw;
  max-height:400px;
  min-height:300px;

    }
    @media only screen and (max-width: 992px) {
      width: 100%;
      min-height: 158px;
      height: 100%;
    }
    @media only screen and (max-width: 500px) {
      width: 100%;
       max-width: 90%;
       min-width: 90%;

      min-height: 100px;
      height: 55vw;
    }
    position: relative;
    perspective: 1000px;
    transform-style: preserve-3d;
    [type="radio"] {
      display: none;
    }
    & > div {
      height: 100%;
      width: 100%;
      max-width: 100%;
      border-radius: 8px;
      position: absolute;
      left: 0;
      right: 0;
      cursor: pointer;
      transition: all 0.3s ease-out;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;
